<mat-expansion-panel
	class="au-section-panel"
	hideToggle
	[expanded]="expanded"
	(closed)="closed.emit()"
	(opened)="opened.emit()"
	#sectionPanel
>
	<mat-expansion-panel-header class="section-header">
		<mat-panel-title>
			@if (showSectionIcon) {
				<span class="arrow" [class.rotate-right-90]="!sectionPanel.expanded">
					<mat-icon svgIcon="arrow_down" />
				</span>
			}
			@if (title) {
				<span class="section-name">{{ title }}</span>
			}
			<ng-content select="[title-element]"> </ng-content>
		</mat-panel-title>
	</mat-expansion-panel-header>

	<div class="section-container">
		<ng-content />
	</div>
</mat-expansion-panel>
